import { render, staticRenderFns } from "./TctProd.vue?vue&type=template&id=19ac5963&"
import script from "./TctProd.vue?vue&type=script&lang=js&"
export * from "./TctProd.vue?vue&type=script&lang=js&"
import style0 from "./TctProd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports